import { Product } from "@/types/product-search";
import { useTranslations } from "next-intl";
import { sizesSort } from "@repo/next-shared/utils";

export default function SizeBadge({ product }: { product: Product }) {
  const t = useTranslations("Products-list");
  const computeSizes = () => {
    const sizes = product.variants
      .filter((v) => v.available)
      .map((v) => v.size);

    if (sizes.length > 4) {
      return t("more-sizes");
    }

    const uniqueSizes = [...new Set(sizes)];

    return (
      <div className="flex gap-x-4 flex-wrap">
        {sizesSort(uniqueSizes).map((size) => (
          <span className="text-[14px]" key={size}>
            {size}
          </span>
        ))}
      </div>
    );
  };

  return <div className="mt-2">{computeSizes()}</div>;
}
